import React from 'react';
import Login from './login';
import { SnackbarProvider, useSnackbar } from 'notistack';
import Register from './register';
import { getAblyToken } from './ably';
import { Realtime } from 'ably';
import Logout from './Logout';
import Authorize from './Authorize';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [session, setSession] = React.useState(null);
  const [token, setToken] = React.useState(null);
  const [appId, setAppId] = React.useState(null);
  const [sessionId, setSessionID] = React.useState(null);
  const [currentRoute, setCurrentRoute] = React.useState('egister');
  React.useEffect(async () => {
    let urlParams1 = new URLSearchParams(window.location.search);
    let session = urlParams1.get('session');
    let token = urlParams1.get('token');
    let AppId = urlParams1.get('appId');
    let session_Id = urlParams1.get('sid');
    setSession(session);
    setToken(token);
    setAppId(AppId);
    setSessionID(session_Id);

    const ablyToken = await getAblyToken();
    const ably = new Realtime({ token: ablyToken });
    ably.connection.on(function (stateChange) {
      if (
        stateChange.current == 'disconnected' ||
        stateChange.current == 'suspended' ||
        stateChange.current == 'closed' ||
        stateChange.current == 'failed' ||
        stateChange.current == 'closing'
      ) {
        enqueueSnackbar(stateChange.current, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
          persist: true,
        });
      }
      if (stateChange.current == 'connected') {
        enqueueSnackbar(stateChange.current, {
          variant: 'success',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        });
      }
    });
  }, []);
  if (currentRoute == 'register')
    return (
      <Register setCurrentRoute={setCurrentRoute} token={token} appId={appId} />
    );
  return (
    <>
      <Router>
        <React.Fragment>
          <Routes>
            {((token && appId && sessionId) || session) && (
              <Route
                exact
                path='/'
                element={
                  <Login
                    session={session}
                    appId={appId}
                    token={token}
                    sid={sessionId}
                    setCurrentRoute={setCurrentRoute}
                  />
                }
              />
            )}
            <Route exact path='/logout' element={<Logout />} />
            <Route exact path='/authorize' element={<Authorize />} />
          </Routes>
        </React.Fragment>
      </Router>
    </>
  );
}

export default function AppWithNotistack() {
  return (
    <SnackbarProvider maxSnack={1}>
      <App />
    </SnackbarProvider>
  );
}
